export const threeStar = {
  "three-star": {
    shape:
      '<path fill="#000" fill-opacity=".51" d="m18 8.2-.875-1.95-1.925-.875 1.925-.85.875-1.95.875 1.95 1.925.85-1.925.875L18 8.2Zm0 13.225-.875-1.95-1.925-.85 1.925-.875L18 15.8l.875 1.95 1.925.875-1.925.85-.875 1.95Zm-9.225-3.85-1.725-3.85L3.2 12l3.85-1.725 1.725-3.85 1.725 3.85L14.35 12l-3.85 1.725-1.725 3.85Zm0-2.425 1-2.15 2.15-1-2.15-1-1-2.15-1 2.15-2.15 1 2.15 1 1 2.15Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
